import axios from "store/axios-broker";
import * as types from "store/types.js";
import { show as notifySuccess } from "store/actions/notice";

const started = (request) => {
  return {
      type: types.RESETPASSWORD_START,
      request: request,
      error: null
  };
};

const succeeded = () => {
  return {
      type: types.RESETPASSWORD_SUCCESS,
      error: null
  };
};

const failed = (error) => {
  return {
      type: types.RESETPASSWORD_FAILURE,
      error: error && error.data && error.data.code ? error.data.code : "000"
  };
};

const querystring = require('querystring');
export const reset = (email, password, code) => {
  return dispatch => {
    dispatch(started('reset'));
    const body = {
        alias: email,
        password: password,
        otp: code
    };
    axios.post("/apex/certify/password/" + email + "/reset",
                querystring.stringify(body), { urlencoded: true }
    ).then(response => {
      dispatch(succeeded());
      dispatch(notifySuccess("password"));             
    }).catch(error => {
      dispatch(failed(error.response));
    });
  };
};